<template>
  <div>
    <top-message />
    <div class="bottomPart">
      <div class="titlePart">历史记录</div>
      <div class="applyTime">
        <el-form
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
          style="border-bottom: 1px solid #F3F4F9;padding: 0 30px ;display:flex;justify-content: space-between;"
        >
          <el-form-item label="上报年份">
            <div class="block">
              <el-date-picker
                style="width: 200px"
                v-model="searchForm.year"
                type="year"
                format="yyyy年"
                value-format="yyyy"
                placeholder="请选择"
                clearable
                @change="head"
              >
              </el-date-picker>
            </div>
          </el-form-item>

          <el-form-item label="上报月份">
            <el-select
              v-model="searchForm.month"
              placeholder="请选择"
              style="width: 200px"
              clearable
              @change="head"
            >
              <el-option
                v-for="item in statusOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上报状态">
            <el-select
              @change="query()"
              v-model="searchForm.reportStatus"
              placeholder="请选择"
              style="width: 200px"
              clearable
            >
              <el-option
                v-for="item in bankOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column
          prop="year"
          label="所属年份"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="month"
          label="所属月份"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="上报时间"
        >
        </el-table-column>
        <el-table-column
          prop="status"
          label="上报状态"
        >
        </el-table-column>
        <el-table-column
          prop="path"
          label="操作"
        >
          <template slot-scope="scope">
            <a
              @click="down(scope.row.path)"
              style="font-size: 15px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #2981EE;"
            >下载</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import utils from "@/utils/utils"
import TopMessage from "@/components/TopMessage";
import { businessReportHistoryRecord } from "@/api/statistics";
import baseUrl from "@/api/baseUrl";
export default {
  components: { TopMessage },
  data () {
    return {
      searchForm: {
        year: "",
        month: "",
        status: "",
      },
      statusOption: [
        { value: "01", label: "1月" },
        { value: "02", label: "2月" },
        { value: "03", label: "3月" },
        { value: "04", label: "4月" },
        { value: "05", label: "5月" },
        { value: "06", label: "6月" },
        { value: "07", label: "7月" },
        { value: "08", label: "8月" },
        { value: "09", label: "9月" },
        { value: "10", label: "10月" },
        { value: "11", label: "11月" },
        { value: "12", label: "12月" },
      ],
      bankOption: [
        { value: "0", label: "成功" },
        { value: "2", label: "逾期" },
      ],
      tableData: []
    }
  },
  created () {
    this.query()
  },
  methods: {
    head () {
      this.query()
    },
    query () {
      businessReportHistoryRecord(this.sendParam(this.searchForm)).then(res => {
        res = this.paramDecrypt(res);

        if (res.code == 200) {
          // res.data.forEach((item) => {
          //   item.createTime = utils.timestamps(item.createTime)
          // })
          this.tableData = res.data
        }
      }).catch(err => {

      })
    },
    down (e) {
      const xhr = new XMLHttpRequest();
      xhr.open("post", this.baseUrl + "/api/v1/file/downBusinessReport", true);  // get、post都可
      xhr.responseType = "blob";  // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded")
      xhr.onload = function () {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = "信易贷报送文档.zip";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a")
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click()
            window.URL.revokeObjectURL(url)
          }
        }
      }
      xhr.send("path=" + e);
    }
  }

}
</script>
<style lang="less" scoped>
.bottomPart {
  width: 100%;
  height: 740px;
  background: #fff;
  box-sizing: border-box;
  padding-top: 20px;
  font-size: 14px;
  border-radius: 6px;
  margin-top: 20px;
  .titlePart {
    color: #2981ee;
    font-size: 24px;
    font-weight: bold;
    border-left: 6px solid #2981ee;
    padding-left: 20px;
    margin-bottom: 20px;
  }
}
.applyTime {
  width: 100%;
}
.title {
  width: 100%;
  height: 45px;
  background: #f3f4f9;
  box-sizing: border-box;
}
.titleBox {
  width: 100%;
  height: 45px;
  background: #f3f4f9;
  padding: 0px 70px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.titleBtn {
  width: 100%;
  height: 45px;
  padding: 0px 70px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f3f4f9;
}
/deep/.el-table th {
  text-align: center;
  background-color: #f5f6fa;
}
/deep/.el-table td {
  text-align: center;
}
</style>
